import React from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Section from "../../blocks/Section/Section";
import { useArticles } from "./ArticlesSection.hooks";
import useCategories from "../../categories/useCategories";

import "./Sections.scss";
import { useLinks } from "../../../services/helpers/links";
import { ArticleCardWrapper } from "../Article/ArticleCardWrapper";

const ArticlesSection = ({ t, category, subtitle, limit }) => {
  const { articles } = useArticles({
    limit,
    category,
  });
  const { categories } = useCategories();
  const categoryDetails = categories.find(({ id }) => id === category);

  return (
    <Section
      title={
        <h2>
          {categoryDetails.name}
          <small>{subtitle}</small>
        </h2>
      }
    >
      <>
        <div className="Sections__subtitle">
          {t("widgets:news.latest")}
          <Link to={categoryDetails.path} className="Sections__more">
            {t("widgets:news.allArticles")}
          </Link>
        </div>
        <br />
        <div className="Sections__articles">
          {articles.slice(0, limit || 8).map(({ id, ...el }) => (
            <ArticleCardWrapper article={el} key={el.id} id={el.id} />
          ))}
        </div>
      </>
    </Section>
  );
};

ArticlesSection.defaultProps = {
  articles: [],
};

export default withTranslation(["widgets"])(ArticlesSection);
